/* eslint-disable @typescript-eslint/camelcase */
import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
}

export default {
  getEnvironmentMaintenance: (environment_uuid: string) =>
    `/maintenance/environment/${environment_uuid}/`,
  getClientMaintenance: (client_uuid: string) =>
    `/maintenance/client/${client_uuid}/`,
  setEnvironmentMaintenance: (environment_uuid: string) =>
    `/maintenance/environment/${environment_uuid}/`,
  setClientMaintenance: (client_uuid: string) =>
    `/maintenance/client/${client_uuid}/`,
  getEnvironmentMaintenanceHistory: (
    environment_uuid: string,
    query: QueryProps
  ) =>
    `/maintenance/environment/${environment_uuid}/history/?${objToQueryString(
      query
    )}`,
  getClientMaintenanceHistory: (client_uuid: string, query: QueryProps) =>
    `/maintenance/client/${client_uuid}/history/?${objToQueryString(query)}`,
  retrieveEnvironmentMaintenanceHistory: (
    environment_uuid: string,
    request_uuid: string
  ) => `/maintenance/environment/${environment_uuid}/history/${request_uuid}/`,
  retrieveClientMaintenanceHistory: (
    client_uuid: string,
    request_uuid: string
  ) => `/maintenance/client/${client_uuid}/history/${request_uuid}/`,
};
